/**
 * Dictionary access.
 *
 * `useT()` subscribes to the locale store, so a language change re-renders the
 * text and nothing else: the map instance, the selected episode and the
 * timeline cursor live outside React state and are untouched by it.
 *
 * There is deliberately no non-reactive getter. Module-level code that used to
 * want one — the base-map catalogue, the legend rows, the date presets — now
 * stores a *key* into the dictionary and resolves it at render, which cannot
 * go stale the way a string captured at import time does.
 */
import { useLocaleStore, type Locale } from "../store/localeStore";

import { en } from "./en";
import { kk } from "./kk";
import { ru, type Dictionary } from "./ru";

const DICTIONARIES: Record<Locale, Dictionary> = { ru, kk, en };

export function useT(): Dictionary {
  return DICTIONARIES[useLocaleStore((s) => s.locale)];
}

export type { Dictionary };
